import { paths } from '@config/paths';

export type NavigationItemId =
	| 'leads'
	| 'conversations'
	| 'inventory'
	| 'orders'
	| 'preorders'
	| 'discounts'
	| 'usage'
	| 'analytics'
	| 'settings'
	| 'plan-details'
	| 'documentation'
	| 'reports';

export interface NavigationItemConfig {
	/** Unique identifier for this navigation item */
	id: NavigationItemId;
	/** Route path config, or null if the item has no route (e.g. external link) */
	path: (typeof paths)[keyof typeof paths] | null;
}

export const NAVIGATION_ITEMS: Record<NavigationItemId, NavigationItemConfig> = {
	orders: {
		id: 'orders',
		path: paths.orders,
	},
	preorders: {
		id: 'preorders',
		path: paths.preorders,
	},
	discounts: {
		id: 'discounts',
		path: paths.discounts,
	},
	inventory: {
		id: 'inventory',
		path: paths.inventory,
	},
	leads: {
		id: 'leads',
		path: paths.leads,
	},
	conversations: {
		id: 'conversations',
		path: paths.conversations,
	},
	usage: {
		id: 'usage',
		path: paths.usage,
	},
	analytics: {
		id: 'analytics',
		path: paths.analytics,
	},
	settings: {
		id: 'settings',
		path: paths.settings,
	},
	'plan-details': {
		id: 'plan-details',
		path: paths.plan_details,
	},
	documentation: {
		id: 'documentation',
		path: null,
	},
	reports: {
		id: 'reports',
		path: paths.reports,
	},
};
